import { gql } from "graphql-request";

export const CREATE_AGENCY_SALE_DETAIL = gql`
  mutation CREATE_AGENCY_SALE_DETAIL(
    $agencyId: Int!
    $userId: Int!
    $coins: Float!
    $isAgency: Boolean!
  ) {
    createAgencySaleDetail(
      agencyId: $agencyId
      userId: $userId
      coins: $coins
      isAgency: $isAgency
    ) {
      error
      status
      data
    }
  }
`;
